/*
* Extra Payment Form.
*/
Extra_payment = {
	init : function()
	{
		Extra_payment.init_ui();
	},
	init_ui : function()
	{
		var arrival_field = jQuery('#arrival-extra-payment');
		
		// Set Arrival to Readonly.
		arrival_field.prop('readonly', true);
		
		// Turn Arrival DatePicker on.
		arrival_field.datepicker({
			minDate: 0,
			maxDate: '+712D',
			numberOfMonths: 1,
			dateFormat : 'd M yy',
			buttonImage: '',
			buttonImageOnly: false,
		});
		console.log('Extra Payment');
	}
}

jQuery(document).ready(function(jQuery){
	Extra_payment.init();
});